import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { JwtService } from '../services/jwt.service';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(
    private jwtService: JwtService,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headersConfig: any = {};
    
    if (req.url !== '/api/DynamicForms/upload_documents') {
      headersConfig['Content-Type'] = 'application/json';
      headersConfig['Accept'] = 'application/json';
    }

    return from(this.jwtService.getToken()).pipe(
      switchMap((token) => {
        if (token) {
          if (!req.url.includes('sendMessageWithHttp')) {
            this.authService.getClientDetailsFromToken(token);
            headersConfig['Authorization'] = `${token}`;
            headersConfig['KAuthorization'] = `${token}`;
          }
        }

        // Determine the final clean URL safely
        let targetUrl = req.url;

        // Only prepend environment.api.url if targetUrl is NOT already an absolute HTTP(S) URL
        if (!targetUrl.startsWith('http://') && !targetUrl.startsWith('https://')) {
          const baseUrl = environment.api.url.replace(/\/+$/, ''); // Trim trailing slashes
          const cleanPath = targetUrl.replace(/^\/+/, '');          // Trim leading slashes
          targetUrl = `${baseUrl}/${cleanPath}`;
        }

        const request = req.clone({
          setHeaders: headersConfig,
          url: targetUrl,
        });

        return next.handle(request);
      })
    );
  }
}